import cloudDispatcher from "./CloudDispatcher";
import { cloudStoreActions } from "./CloudStore";
import { _get } from "../Api";
import { getProfilesFromMerchant } from "../authorization/authorizations";

export function getMerchantFromServer(merchantId) {
  return new Promise((resolve) => {
    _get("/nova/merchant/" + merchantId).then((response) => {
      setUserProfiles(getProfilesFromMerchant(response.data));
      setMerchant(response.data);
      resolve(response.data);
    });
  });
}

export function setMerchant(merchant) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_MERCHANT,
    merchant,
  });
}

export function setTaMerchant(taMerchant) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_TA_MERCHANT,
    taMerchant,
  });
}

export function setSpMerchant(spMerchant) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_SP_MERCHANT,
    spMerchant,
  });
}

export function setPillarMerchant(pillarMerchant) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_PILLAR_MERCHANT,
    pillarMerchant,
  });
}

export function setFilteredMerchants(merchants) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_FILTERED_MERCHANTS,
    filteredMerchants: merchants,
  });
}

export function setMerchants(merchants) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_MERCHANTS,
    merchants,
  });
}

const mapper = (row) => {
  let ta_color;
  if (row.ta_merchants && row.ta_merchants.length > 0 && !!row.ta_merchants[0].active) {
    ta_color = "#50e993";
  } else if (row.ta_merchants && row.ta_merchants.length > 0) {
    ta_color = "#E94F37";
  } else {
    ta_color = undefined;
  }

  let sp_color;
  if (row.sp_merchants && row.sp_merchants.length > 0 && !!row.sp_merchants[0].active) {
    sp_color = "#50e993";
  } else if (row.sp_merchants && row.sp_merchants.length > 0) {
    sp_color = "#E94F37";
  } else {
    sp_color = undefined;
  }
  return {
    ...row,
    merchant_id: row.id,
    ta_active: ta_color,
    sp_active: sp_color,
  };
};

function getMerchants() {
  return _get("/nova/merchant")
    .then((res) => {
      const merchants = res.data.map(mapper);
      setMerchants(merchants);
      return merchants;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getFilteredMerchants() {
  return new Promise((resolve, reject) => {
    getMerchants().then((merchants) => {
      setFilteredMerchants(merchants);
      resolve();
    });
  });
}

export function setTakeawayDeliverySettings(settings) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_TAKEAWAY_DELIVERY_SETTINGS,
    takeawayDeliverySettings: settings,
  });
}

export function setUserRoles(userRoles) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_USER_ROLES,
    userRoles,
  });
}

export function setUserProfiles(userProfiles) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_USER_PROFILES,
    userProfiles,
  });
}

export function setRoles(roles) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_ROLES,
    roles,
  });
}

export function setProfiles(profiles) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_PROFILES,
    profiles,
  });
}

export function setAuthentications(authentications) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_AUTHENTICATIONS,
    authentications,
  });
}

export function setLoading(loading) {
  cloudDispatcher.dispatch({
    type: cloudStoreActions.SET_LOADING,
    loading,
  });
}
